import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StripePaymentElementOptions } from '@stripe/stripe-js';
import { StripePaymentElementComponent, StripeService } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { Account } from 'src/models/account.model';
import { PaymentService } from 'src/services/payment.service';
import { UsersService } from 'src/services/users.service';

@Component({
  selector: 'app-mobile-app-payment-methods',
  templateUrl: './mobile-app-payment-methods.component.html',
  styleUrls: ['./mobile-app-payment-methods.component.scss'],
})
export class MobileAppPaymentMethodsComponent implements OnInit, AfterViewInit {
  @ViewChild('stripePaymentCtrl') stripePaymentCtrl: StripePaymentElementComponent;
  account: Account;
  accountId: number;
  isTest = false;
  isLoading = false;
  keys: {
    paymentIntentClientSecret: string;
    customerEphemeralKeySecret: string;
    customerId: string;
  }
  errorMessage: string;
  options: StripePaymentElementOptions;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UsersService,
    private stripeService: StripeService,
    private paymentService: PaymentService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.route.queryParamMap.subscribe(params => {
      if (params.has('isTest')) {
        this.isTest = params.get('isTest') == 'true';
        this.stripeService.changeKey(environment.stripe.forceTestPayment || this.isTest ? environment.stripe.testPublishableKey : environment.stripe.publishableKey);
      }
      
      if (params.has('accountId')) {
        this.accountId = Number(params.get('accountId'));
      }
    });
  }

  async ngAfterViewInit() {
    this.account = await this.userService.getAccount(this.accountId);
    await this.initStripeElement();
  }

  changePaymentMethod(data) {
    console.log(data);
  }

  async initStripeElement() {
    this.isLoading = true;

    this.options = {
      defaultValues: {
        billingDetails: {
          name: `${this.account.firstName} ${this.account.lastName}`,
          email: this.account.emailAddress
        }
      },
      wallets: {
        applePay: 'never',
        googlePay: 'never'
      }
    }
    
    try {
      this.keys = await this.paymentService.getSetupIntentKeys(this.accountId, this.isTest);
    } catch (err) {
      console.error(err);
      alert('Error: ' + JSON.stringify(err));
    } finally {
      this.isLoading = false;
    }
    
  }

  save() {
    this.errorMessage = undefined;
    this.stripeService
      .confirmSetup({
        elements: this.stripePaymentCtrl.elements,
        confirmParams: {
          return_url: `${window.location.origin}/mobile-app/completed`
        },
        redirect: 'if_required'
      })
      .subscribe(async result => {
        console.log('Result', result);
        const paymentMethodId = typeof result.setupIntent.payment_method == 'string' ? result.setupIntent.payment_method : result.setupIntent.payment_method.id;

        if (result.error) {
          this.errorMessage = result.error.message;
        } else {
          this.isLoading = true;
          try {
            await this.paymentService.savePaymentMethod(paymentMethodId, this.accountId, this.keys.customerId, this.isTest);
            await this.router.navigate(['/mobile-app/completed']);
          } catch (err) {
            const errorMessage = (err.error || err.message);

            if (this.errorMessage.includes('verify')) {
              await this.router.navigate([`/mobile-app/completed?message=${errorMessage}`]);
            } else {
              this.errorMessage = errorMessage + ' . You may close this page.'
            }
          } finally {
            this.isLoading = false;
          }
        }
      });
  }

}
